(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@fdn/rating-star')) :
	typeof define === 'function' && define.amd ? define('@fdn/review_card_bs', ['react', '@fdn/rating-star'], factory) :
	(global = global || self, global['@fdn/review_card_bs'] = factory(global.React, global.RatingStar));
}(this, (function (e$1, RatingStar) { 'use strict';

	var e$1__default = 'default' in e$1 ? e$1['default'] : e$1;
	RatingStar = RatingStar && Object.prototype.hasOwnProperty.call(RatingStar, 'default') ? RatingStar['default'] : RatingStar;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	function _typeof(o) {
	  "@babel/helpers - typeof";

	  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, _typeof(o);
	}
	function _extends() {
	  _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	  return _extends.apply(this, arguments);
	}
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = _objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	function _slicedToArray(arr, i) {
	  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
	}
	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
	}
	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	var b = "function" === typeof Symbol && Symbol["for"],
	  c = b ? Symbol["for"]("react.element") : 60103,
	  d = b ? Symbol["for"]("react.portal") : 60106,
	  e = b ? Symbol["for"]("react.fragment") : 60107,
	  f = b ? Symbol["for"]("react.strict_mode") : 60108,
	  g = b ? Symbol["for"]("react.profiler") : 60114,
	  h = b ? Symbol["for"]("react.provider") : 60109,
	  k = b ? Symbol["for"]("react.context") : 60110,
	  l = b ? Symbol["for"]("react.async_mode") : 60111,
	  m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
	  n = b ? Symbol["for"]("react.forward_ref") : 60112,
	  p = b ? Symbol["for"]("react.suspense") : 60113,
	  q = b ? Symbol["for"]("react.suspense_list") : 60120,
	  r = b ? Symbol["for"]("react.memo") : 60115,
	  t = b ? Symbol["for"]("react.lazy") : 60116,
	  v = b ? Symbol["for"]("react.block") : 60121,
	  w = b ? Symbol["for"]("react.fundamental") : 60117,
	  x = b ? Symbol["for"]("react.responder") : 60118,
	  y = b ? Symbol["for"]("react.scope") : 60119;
	function z(a) {
	  if ("object" === _typeof(a) && null !== a) {
	    var u = a.$$typeof;
	    switch (u) {
	      case c:
	        switch (a = a.type, a) {
	          case l:
	          case m:
	          case e:
	          case g:
	          case f:
	          case p:
	            return a;
	          default:
	            switch (a = a && a.$$typeof, a) {
	              case k:
	              case n:
	              case t:
	              case r:
	              case h:
	                return a;
	              default:
	                return u;
	            }
	        }
	      case d:
	        return u;
	    }
	  }
	}
	function A(a) {
	  return z(a) === m;
	}
	var AsyncMode = l;
	var ConcurrentMode = m;
	var ContextConsumer = k;
	var ContextProvider = h;
	var Element = c;
	var ForwardRef = n;
	var Fragment = e;
	var Lazy = t;
	var Memo = r;
	var Portal = d;
	var Profiler = g;
	var StrictMode = f;
	var Suspense = p;
	var isAsyncMode = function isAsyncMode(a) {
	  return A(a) || z(a) === l;
	};
	var isConcurrentMode = A;
	var isContextConsumer = function isContextConsumer(a) {
	  return z(a) === k;
	};
	var isContextProvider = function isContextProvider(a) {
	  return z(a) === h;
	};
	var isElement = function isElement(a) {
	  return "object" === _typeof(a) && null !== a && a.$$typeof === c;
	};
	var isForwardRef = function isForwardRef(a) {
	  return z(a) === n;
	};
	var isFragment = function isFragment(a) {
	  return z(a) === e;
	};
	var isLazy = function isLazy(a) {
	  return z(a) === t;
	};
	var isMemo = function isMemo(a) {
	  return z(a) === r;
	};
	var isPortal = function isPortal(a) {
	  return z(a) === d;
	};
	var isProfiler = function isProfiler(a) {
	  return z(a) === g;
	};
	var isStrictMode = function isStrictMode(a) {
	  return z(a) === f;
	};
	var isSuspense = function isSuspense(a) {
	  return z(a) === p;
	};
	var isValidElementType = function isValidElementType(a) {
	  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
	};
	var typeOf = z;
	var reactIs_production_min = {
	  AsyncMode: AsyncMode,
	  ConcurrentMode: ConcurrentMode,
	  ContextConsumer: ContextConsumer,
	  ContextProvider: ContextProvider,
	  Element: Element,
	  ForwardRef: ForwardRef,
	  Fragment: Fragment,
	  Lazy: Lazy,
	  Memo: Memo,
	  Portal: Portal,
	  Profiler: Profiler,
	  StrictMode: StrictMode,
	  Suspense: Suspense,
	  isAsyncMode: isAsyncMode,
	  isConcurrentMode: isConcurrentMode,
	  isContextConsumer: isContextConsumer,
	  isContextProvider: isContextProvider,
	  isElement: isElement,
	  isForwardRef: isForwardRef,
	  isFragment: isFragment,
	  isLazy: isLazy,
	  isMemo: isMemo,
	  isPortal: isPortal,
	  isProfiler: isProfiler,
	  isStrictMode: isStrictMode,
	  isSuspense: isSuspense,
	  isValidElementType: isValidElementType,
	  typeOf: typeOf
	};

	var reactIs_development = createCommonjsModule(function (module, exports) {

	  if (process.env.NODE_ENV !== "production") {
	    (function () {

	      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	      // nor polyfill, then a plain number is used for performance.
	      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
	      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
	      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
	      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
	      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
	      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
	      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
	      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	      // (unstable) APIs that have been removed. Can we remove the symbols?

	      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
	      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
	      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
	      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
	      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
	      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
	      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
	      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
	      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
	      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
	      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
	      function isValidElementType(type) {
	        return typeof type === 'string' || typeof type === 'function' ||
	        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	      }
	      function typeOf(object) {
	        if (_typeof(object) === 'object' && object !== null) {
	          var $$typeof = object.$$typeof;
	          switch ($$typeof) {
	            case REACT_ELEMENT_TYPE:
	              var type = object.type;
	              switch (type) {
	                case REACT_ASYNC_MODE_TYPE:
	                case REACT_CONCURRENT_MODE_TYPE:
	                case REACT_FRAGMENT_TYPE:
	                case REACT_PROFILER_TYPE:
	                case REACT_STRICT_MODE_TYPE:
	                case REACT_SUSPENSE_TYPE:
	                  return type;
	                default:
	                  var $$typeofType = type && type.$$typeof;
	                  switch ($$typeofType) {
	                    case REACT_CONTEXT_TYPE:
	                    case REACT_FORWARD_REF_TYPE:
	                    case REACT_LAZY_TYPE:
	                    case REACT_MEMO_TYPE:
	                    case REACT_PROVIDER_TYPE:
	                      return $$typeofType;
	                    default:
	                      return $$typeof;
	                  }
	              }
	            case REACT_PORTAL_TYPE:
	              return $$typeof;
	          }
	        }
	        return undefined;
	      } // AsyncMode is deprecated along with isAsyncMode

	      var AsyncMode = REACT_ASYNC_MODE_TYPE;
	      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	      var ContextConsumer = REACT_CONTEXT_TYPE;
	      var ContextProvider = REACT_PROVIDER_TYPE;
	      var Element = REACT_ELEMENT_TYPE;
	      var ForwardRef = REACT_FORWARD_REF_TYPE;
	      var Fragment = REACT_FRAGMENT_TYPE;
	      var Lazy = REACT_LAZY_TYPE;
	      var Memo = REACT_MEMO_TYPE;
	      var Portal = REACT_PORTAL_TYPE;
	      var Profiler = REACT_PROFILER_TYPE;
	      var StrictMode = REACT_STRICT_MODE_TYPE;
	      var Suspense = REACT_SUSPENSE_TYPE;
	      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	      function isAsyncMode(object) {
	        {
	          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	          }
	        }
	        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	      }
	      function isConcurrentMode(object) {
	        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	      }
	      function isContextConsumer(object) {
	        return typeOf(object) === REACT_CONTEXT_TYPE;
	      }
	      function isContextProvider(object) {
	        return typeOf(object) === REACT_PROVIDER_TYPE;
	      }
	      function isElement(object) {
	        return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	      }
	      function isForwardRef(object) {
	        return typeOf(object) === REACT_FORWARD_REF_TYPE;
	      }
	      function isFragment(object) {
	        return typeOf(object) === REACT_FRAGMENT_TYPE;
	      }
	      function isLazy(object) {
	        return typeOf(object) === REACT_LAZY_TYPE;
	      }
	      function isMemo(object) {
	        return typeOf(object) === REACT_MEMO_TYPE;
	      }
	      function isPortal(object) {
	        return typeOf(object) === REACT_PORTAL_TYPE;
	      }
	      function isProfiler(object) {
	        return typeOf(object) === REACT_PROFILER_TYPE;
	      }
	      function isStrictMode(object) {
	        return typeOf(object) === REACT_STRICT_MODE_TYPE;
	      }
	      function isSuspense(object) {
	        return typeOf(object) === REACT_SUSPENSE_TYPE;
	      }
	      exports.AsyncMode = AsyncMode;
	      exports.ConcurrentMode = ConcurrentMode;
	      exports.ContextConsumer = ContextConsumer;
	      exports.ContextProvider = ContextProvider;
	      exports.Element = Element;
	      exports.ForwardRef = ForwardRef;
	      exports.Fragment = Fragment;
	      exports.Lazy = Lazy;
	      exports.Memo = Memo;
	      exports.Portal = Portal;
	      exports.Profiler = Profiler;
	      exports.StrictMode = StrictMode;
	      exports.Suspense = Suspense;
	      exports.isAsyncMode = isAsyncMode;
	      exports.isConcurrentMode = isConcurrentMode;
	      exports.isContextConsumer = isContextConsumer;
	      exports.isContextProvider = isContextProvider;
	      exports.isElement = isElement;
	      exports.isForwardRef = isForwardRef;
	      exports.isFragment = isFragment;
	      exports.isLazy = isLazy;
	      exports.isMemo = isMemo;
	      exports.isPortal = isPortal;
	      exports.isProfiler = isProfiler;
	      exports.isStrictMode = isStrictMode;
	      exports.isSuspense = isSuspense;
	      exports.isValidElementType = isValidElementType;
	      exports.typeOf = typeOf;
	    })();
	  }
	});
	var reactIs_development_1 = reactIs_development.AsyncMode;
	var reactIs_development_2 = reactIs_development.ConcurrentMode;
	var reactIs_development_3 = reactIs_development.ContextConsumer;
	var reactIs_development_4 = reactIs_development.ContextProvider;
	var reactIs_development_5 = reactIs_development.Element;
	var reactIs_development_6 = reactIs_development.ForwardRef;
	var reactIs_development_7 = reactIs_development.Fragment;
	var reactIs_development_8 = reactIs_development.Lazy;
	var reactIs_development_9 = reactIs_development.Memo;
	var reactIs_development_10 = reactIs_development.Portal;
	var reactIs_development_11 = reactIs_development.Profiler;
	var reactIs_development_12 = reactIs_development.StrictMode;
	var reactIs_development_13 = reactIs_development.Suspense;
	var reactIs_development_14 = reactIs_development.isAsyncMode;
	var reactIs_development_15 = reactIs_development.isConcurrentMode;
	var reactIs_development_16 = reactIs_development.isContextConsumer;
	var reactIs_development_17 = reactIs_development.isContextProvider;
	var reactIs_development_18 = reactIs_development.isElement;
	var reactIs_development_19 = reactIs_development.isForwardRef;
	var reactIs_development_20 = reactIs_development.isFragment;
	var reactIs_development_21 = reactIs_development.isLazy;
	var reactIs_development_22 = reactIs_development.isMemo;
	var reactIs_development_23 = reactIs_development.isPortal;
	var reactIs_development_24 = reactIs_development.isProfiler;
	var reactIs_development_25 = reactIs_development.isStrictMode;
	var reactIs_development_26 = reactIs_development.isSuspense;
	var reactIs_development_27 = reactIs_development.isValidElementType;
	var reactIs_development_28 = reactIs_development.typeOf;

	var reactIs = createCommonjsModule(function (module) {

	  if (process.env.NODE_ENV === 'production') {
	    module.exports = reactIs_production_min;
	  } else {
	    module.exports = reactIs_development;
	  }
	});
	var reactIs_1 = reactIs.typeOf;
	var reactIs_2 = reactIs.isElement;
	var reactIs_3 = reactIs.isValidElementType;

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	function toObject(val) {
	  if (val === null || val === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }
	  return Object(val);
	}
	function shouldUseNative() {
	  try {
	    if (!Object.assign) {
	      return false;
	    }

	    // Detect buggy property enumeration order in older V8 versions.

	    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
	    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
	    test1[5] = 'de';
	    if (Object.getOwnPropertyNames(test1)[0] === '5') {
	      return false;
	    }

	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test2 = {};
	    for (var i = 0; i < 10; i++) {
	      test2['_' + String.fromCharCode(i)] = i;
	    }
	    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	      return test2[n];
	    });
	    if (order2.join('') !== '0123456789') {
	      return false;
	    }

	    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    var test3 = {};
	    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	      test3[letter] = letter;
	    });
	    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
	      return false;
	    }
	    return true;
	  } catch (err) {
	    // We don't expect any of the above to throw, but better to be safe.
	    return false;
	  }
	}
	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	  var from;
	  var to = toObject(target);
	  var symbols;
	  for (var s = 1; s < arguments.length; s++) {
	    from = Object(arguments[s]);
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	    if (getOwnPropertySymbols) {
	      symbols = getOwnPropertySymbols(from);
	      for (var i = 0; i < symbols.length; i++) {
	        if (propIsEnumerable.call(from, symbols[i])) {
	          to[symbols[i]] = from[symbols[i]];
	        }
	      }
	    }
	  }
	  return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	var has = Function.call.bind(Object.prototype.hasOwnProperty);

	var printWarning = function printWarning() {};
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	  var has$1 = has;
	  printWarning = function printWarning(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {/**/}
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has$1(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	          var stack = getStack ? getStack() : '';
	          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function () {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};
	var checkPropTypes_1 = checkPropTypes;

	var printWarning$1 = function printWarning() {};
	if (process.env.NODE_ENV !== 'production') {
	  printWarning$1 = function printWarning(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && _typeof(data) === 'object' ? data : {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (!manualPropTypeCallCache[cacheKey] &&
	          // Avoid spamming the console because they are often not actionable except for lib authors
	          manualPropTypeWarningCount < 3) {
	            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	  }
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
	          expectedType: expectedType
	        });
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!reactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
	        } else {
	          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
	  }
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	  function isNode(propValue) {
	    switch (_typeof(propValue)) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	        return true;
	      default:
	        return false;
	    }
	  }
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = _typeof(propValue);
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	var factoryWithThrowingShims = function factoryWithThrowingShims() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
	    err.name = 'Invariant Violation';
	    throw err;
	  }
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	  ReactPropTypes.PropTypes = ReactPropTypes;
	  return ReactPropTypes;
	};

	var propTypes = createCommonjsModule(function (module) {
	  /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   */

	  if (process.env.NODE_ENV !== 'production') {
	    var ReactIs = reactIs;

	    // By explicitly using `prop-types` you are opting into new development behavior.
	    // http://fb.me/prop-types-in-prod
	    var throwOnDirectAccess = true;
	    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
	  } else {
	    // By explicitly using `prop-types` you are opting into new production behavior.
	    // http://fb.me/prop-types-in-prod
	    module.exports = factoryWithThrowingShims();
	  }
	});

	function _interopDefaultLegacy(e) {
	  return e && _typeof(e) === 'object' && 'default' in e ? e : {
	    'default': e
	  };
	}
	var React__default = /*#__PURE__*/_interopDefaultLegacy(e$1__default);

	/*
	Based on Glamor's sheet
	https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
	*/
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	var isProd = typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production";
	var isString = function isString(o) {
	  return Object.prototype.toString.call(o) === "[object String]";
	};
	var StyleSheet = /*#__PURE__*/function () {
	  function StyleSheet(param) {
	    var ref = param === void 0 ? {} : param,
	      _name = ref.name,
	      name = _name === void 0 ? "stylesheet" : _name,
	      _optimizeForSpeed = ref.optimizeForSpeed,
	      optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
	    invariant$1(isString(name), "`name` must be a string");
	    this._name = name;
	    this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
	    invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
	    this._optimizeForSpeed = optimizeForSpeed;
	    this._serverSheet = undefined;
	    this._tags = [];
	    this._injected = false;
	    this._rulesCount = 0;
	    var node = typeof window !== "undefined" && document.querySelector('meta[property="csp-nonce"]');
	    this._nonce = node ? node.getAttribute("content") : null;
	  }
	  var _proto = StyleSheet.prototype;
	  _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
	    invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
	    invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
	    this.flush();
	    this._optimizeForSpeed = bool;
	    this.inject();
	  };
	  _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
	    return this._optimizeForSpeed;
	  };
	  _proto.inject = function inject() {
	    var _this = this;
	    invariant$1(!this._injected, "sheet already injected");
	    this._injected = true;
	    if (typeof window !== "undefined" && this._optimizeForSpeed) {
	      this._tags[0] = this.makeStyleTag(this._name);
	      this._optimizeForSpeed = "insertRule" in this.getSheet();
	      if (!this._optimizeForSpeed) {
	        if (!isProd) {
	          console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
	        }
	        this.flush();
	        this._injected = true;
	      }
	      return;
	    }
	    this._serverSheet = {
	      cssRules: [],
	      insertRule: function insertRule(rule, index) {
	        if (typeof index === "number") {
	          _this._serverSheet.cssRules[index] = {
	            cssText: rule
	          };
	        } else {
	          _this._serverSheet.cssRules.push({
	            cssText: rule
	          });
	        }
	        return index;
	      },
	      deleteRule: function deleteRule(index) {
	        _this._serverSheet.cssRules[index] = null;
	      }
	    };
	  };
	  _proto.getSheetForTag = function getSheetForTag(tag) {
	    if (tag.sheet) {
	      return tag.sheet;
	    }
	    // this weirdness brought to you by firefox
	    for (var i = 0; i < document.styleSheets.length; i++) {
	      if (document.styleSheets[i].ownerNode === tag) {
	        return document.styleSheets[i];
	      }
	    }
	  };
	  _proto.getSheet = function getSheet() {
	    return this.getSheetForTag(this._tags[this._tags.length - 1]);
	  };
	  _proto.insertRule = function insertRule(rule, index) {
	    invariant$1(isString(rule), "`insertRule` accepts only strings");
	    if (typeof window === "undefined") {
	      if (typeof index !== "number") {
	        index = this._serverSheet.cssRules.length;
	      }
	      this._serverSheet.insertRule(rule, index);
	      return this._rulesCount++;
	    }
	    if (this._optimizeForSpeed) {
	      var sheet = this.getSheet();
	      if (typeof index !== "number") {
	        index = sheet.cssRules.length;
	      }
	      // this weirdness for perf, and chrome's weird bug
	      // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
	      try {
	        sheet.insertRule(rule, index);
	      } catch (error) {
	        if (!isProd) {
	          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
	        }
	        return -1;
	      }
	    } else {
	      var insertionPoint = this._tags[index];
	      this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
	    }
	    return this._rulesCount++;
	  };
	  _proto.replaceRule = function replaceRule(index, rule) {
	    if (this._optimizeForSpeed || typeof window === "undefined") {
	      var sheet = typeof window !== "undefined" ? this.getSheet() : this._serverSheet;
	      if (!rule.trim()) {
	        rule = this._deletedRulePlaceholder;
	      }
	      if (!sheet.cssRules[index]) {
	        // @TBD Should we throw an error?
	        return index;
	      }
	      sheet.deleteRule(index);
	      try {
	        sheet.insertRule(rule, index);
	      } catch (error) {
	        if (!isProd) {
	          console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
	        }
	        // In order to preserve the indices we insert a deleteRulePlaceholder
	        sheet.insertRule(this._deletedRulePlaceholder, index);
	      }
	    } else {
	      var tag = this._tags[index];
	      invariant$1(tag, "old rule at index `" + index + "` not found");
	      tag.textContent = rule;
	    }
	    return index;
	  };
	  _proto.deleteRule = function deleteRule(index) {
	    if (typeof window === "undefined") {
	      this._serverSheet.deleteRule(index);
	      return;
	    }
	    if (this._optimizeForSpeed) {
	      this.replaceRule(index, "");
	    } else {
	      var tag = this._tags[index];
	      invariant$1(tag, "rule at index `" + index + "` not found");
	      tag.parentNode.removeChild(tag);
	      this._tags[index] = null;
	    }
	  };
	  _proto.flush = function flush() {
	    this._injected = false;
	    this._rulesCount = 0;
	    if (typeof window !== "undefined") {
	      this._tags.forEach(function (tag) {
	        return tag && tag.parentNode.removeChild(tag);
	      });
	      this._tags = [];
	    } else {
	      // simpler on server
	      this._serverSheet.cssRules = [];
	    }
	  };
	  _proto.cssRules = function cssRules() {
	    var _this = this;
	    if (typeof window === "undefined") {
	      return this._serverSheet.cssRules;
	    }
	    return this._tags.reduce(function (rules, tag) {
	      if (tag) {
	        rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function (rule) {
	          return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
	        }));
	      } else {
	        rules.push(null);
	      }
	      return rules;
	    }, []);
	  };
	  _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
	    if (cssString) {
	      invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
	    }
	    var tag = document.createElement("style");
	    if (this._nonce) tag.setAttribute("nonce", this._nonce);
	    tag.type = "text/css";
	    tag.setAttribute("data-" + name, "");
	    if (cssString) {
	      tag.appendChild(document.createTextNode(cssString));
	    }
	    var head = document.head || document.getElementsByTagName("head")[0];
	    if (relativeToTag) {
	      head.insertBefore(tag, relativeToTag);
	    } else {
	      head.appendChild(tag);
	    }
	    return tag;
	  };
	  _createClass(StyleSheet, [{
	    key: "length",
	    get: function get() {
	      return this._rulesCount;
	    }
	  }]);
	  return StyleSheet;
	}();
	function invariant$1(condition, message) {
	  if (!condition) {
	    throw new Error("StyleSheet: " + message + ".");
	  }
	}
	function hash(str) {
	  var _$hash = 5381,
	    i = str.length;
	  while (i) {
	    _$hash = _$hash * 33 ^ str.charCodeAt(--i);
	  }
	  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
	  * integers. Since we want the results to be always positive, convert the
	  * signed int to an unsigned by doing an unsigned bitshift. */
	  return _$hash >>> 0;
	}
	var stringHash = hash;
	var sanitize = function sanitize(rule) {
	  return rule.replace(/\/style/gi, "\\/style");
	};
	var cache = {};
	/**
	 * computeId
	 *
	 * Compute and memoize a jsx id from a basedId and optionally props.
	 */
	function computeId(baseId, props) {
	  if (!props) {
	    return "jsx-" + baseId;
	  }
	  var propsToString = String(props);
	  var key = baseId + propsToString;
	  if (!cache[key]) {
	    cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
	  }
	  return cache[key];
	}
	/**
	 * computeSelector
	 *
	 * Compute and memoize dynamic selectors.
	 */
	function computeSelector(id, css) {
	  var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
	  // Sanitize SSR-ed CSS.
	  // Client side code doesn't need to be sanitized since we use
	  // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
	  if (typeof window === "undefined") {
	    css = sanitize(css);
	  }
	  var idcss = id + css;
	  if (!cache[idcss]) {
	    cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
	  }
	  return cache[idcss];
	}
	function mapRulesToStyle(cssRules, options) {
	  if (options === void 0) options = {};
	  return cssRules.map(function (args) {
	    var id = args[0];
	    var css = args[1];
	    return /*#__PURE__*/React__default["default"].createElement("style", {
	      id: "__" + id,
	      // Avoid warnings upon render with a key
	      key: "__" + id,
	      nonce: options.nonce ? options.nonce : undefined,
	      dangerouslySetInnerHTML: {
	        __html: css
	      }
	    });
	  });
	}
	var StyleSheetRegistry = /*#__PURE__*/function () {
	  function StyleSheetRegistry(param) {
	    var ref = param === void 0 ? {} : param,
	      _styleSheet = ref.styleSheet,
	      styleSheet = _styleSheet === void 0 ? null : _styleSheet,
	      _optimizeForSpeed = ref.optimizeForSpeed,
	      optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
	    this._sheet = styleSheet || new StyleSheet({
	      name: "styled-jsx",
	      optimizeForSpeed: optimizeForSpeed
	    });
	    this._sheet.inject();
	    if (styleSheet && typeof optimizeForSpeed === "boolean") {
	      this._sheet.setOptimizeForSpeed(optimizeForSpeed);
	      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	    }
	    this._fromServer = undefined;
	    this._indices = {};
	    this._instancesCounts = {};
	  }
	  var _proto = StyleSheetRegistry.prototype;
	  _proto.add = function add(props) {
	    var _this = this;
	    if (undefined === this._optimizeForSpeed) {
	      this._optimizeForSpeed = Array.isArray(props.children);
	      this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
	      this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
	    }
	    if (typeof window !== "undefined" && !this._fromServer) {
	      this._fromServer = this.selectFromServer();
	      this._instancesCounts = Object.keys(this._fromServer).reduce(function (acc, tagName) {
	        acc[tagName] = 0;
	        return acc;
	      }, {});
	    }
	    var ref = this.getIdAndRules(props),
	      styleId = ref.styleId,
	      rules = ref.rules;
	    // Deduping: just increase the instances count.
	    if (styleId in this._instancesCounts) {
	      this._instancesCounts[styleId] += 1;
	      return;
	    }
	    var indices = rules.map(function (rule) {
	      return _this._sheet.insertRule(rule);
	    }) // Filter out invalid rules
	    .filter(function (index) {
	      return index !== -1;
	    });
	    this._indices[styleId] = indices;
	    this._instancesCounts[styleId] = 1;
	  };
	  _proto.remove = function remove(props) {
	    var _this = this;
	    var styleId = this.getIdAndRules(props).styleId;
	    invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
	    this._instancesCounts[styleId] -= 1;
	    if (this._instancesCounts[styleId] < 1) {
	      var tagFromServer = this._fromServer && this._fromServer[styleId];
	      if (tagFromServer) {
	        tagFromServer.parentNode.removeChild(tagFromServer);
	        delete this._fromServer[styleId];
	      } else {
	        this._indices[styleId].forEach(function (index) {
	          return _this._sheet.deleteRule(index);
	        });
	        delete this._indices[styleId];
	      }
	      delete this._instancesCounts[styleId];
	    }
	  };
	  _proto.update = function update(props, nextProps) {
	    this.add(nextProps);
	    this.remove(props);
	  };
	  _proto.flush = function flush() {
	    this._sheet.flush();
	    this._sheet.inject();
	    this._fromServer = undefined;
	    this._indices = {};
	    this._instancesCounts = {};
	  };
	  _proto.cssRules = function cssRules() {
	    var _this = this;
	    var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function (styleId) {
	      return [styleId, _this._fromServer[styleId]];
	    }) : [];
	    var cssRules = this._sheet.cssRules();
	    return fromServer.concat(Object.keys(this._indices).map(function (styleId) {
	      return [styleId, _this._indices[styleId].map(function (index) {
	        return cssRules[index].cssText;
	      }).join(_this._optimizeForSpeed ? "" : "\n")];
	    }) // filter out empty rules
	    .filter(function (rule) {
	      return Boolean(rule[1]);
	    }));
	  };
	  _proto.styles = function styles(options) {
	    return mapRulesToStyle(this.cssRules(), options);
	  };
	  _proto.getIdAndRules = function getIdAndRules(props) {
	    var css = props.children,
	      dynamic = props.dynamic,
	      id = props.id;
	    if (dynamic) {
	      var styleId = computeId(id, dynamic);
	      return {
	        styleId: styleId,
	        rules: Array.isArray(css) ? css.map(function (rule) {
	          return computeSelector(styleId, rule);
	        }) : [computeSelector(styleId, css)]
	      };
	    }
	    return {
	      styleId: computeId(id),
	      rules: Array.isArray(css) ? css : [css]
	    };
	  };
	  /**
	  * selectFromServer
	  *
	  * Collects style tags from the document with id __jsx-XXX
	  */
	  _proto.selectFromServer = function selectFromServer() {
	    var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
	    return elements.reduce(function (acc, element) {
	      var id = element.id.slice(2);
	      acc[id] = element;
	      return acc;
	    }, {});
	  };
	  return StyleSheetRegistry;
	}();
	function invariant(condition, message) {
	  if (!condition) {
	    throw new Error("StyleSheetRegistry: " + message + ".");
	  }
	}
	var StyleSheetContext = /*#__PURE__*/e$1__default.createContext(null);
	StyleSheetContext.displayName = "StyleSheetContext";
	function createStyleRegistry() {
	  return new StyleSheetRegistry();
	}
	function StyleRegistry(param) {
	  var configuredRegistry = param.registry,
	    children = param.children;
	  var rootRegistry = e$1__default.useContext(StyleSheetContext);
	  var ref = e$1__default.useState(function () {
	      return rootRegistry || configuredRegistry || createStyleRegistry();
	    }),
	    registry = ref[0];
	  return /*#__PURE__*/React__default["default"].createElement(StyleSheetContext.Provider, {
	    value: registry
	  }, children);
	}
	function useStyleRegistry() {
	  return e$1__default.useContext(StyleSheetContext);
	}

	// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
	// https://github.com/reactwg/react-18/discussions/110
	var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
	var defaultRegistry = typeof window !== "undefined" ? createStyleRegistry() : undefined;
	function JSXStyle(props) {
	  var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
	  // If `registry` does not exist, we do nothing here.
	  if (!registry) {
	    return null;
	  }
	  if (typeof window === "undefined") {
	    registry.add(props);
	    return null;
	  }
	  useInsertionEffect(function () {
	    registry.add(props);
	    return function () {
	      registry.remove(props);
	    };
	    // props.children can be string[], will be striped since id is identical
	  }, [props.id, String(props.dynamic)]);
	  return null;
	}
	JSXStyle.dynamic = function (info) {
	  return info.map(function (tagInfo) {
	    var baseId = tagInfo[0];
	    var props = tagInfo[1];
	    return computeId(baseId, props);
	  }).join(" ");
	};
	var StyleRegistry_1 = StyleRegistry;
	var createStyleRegistry_1 = createStyleRegistry;
	var style = JSXStyle;
	var useStyleRegistry_1 = useStyleRegistry;
	var index = {
	  StyleRegistry: StyleRegistry_1,
	  createStyleRegistry: createStyleRegistry_1,
	  style: style,
	  useStyleRegistry: useStyleRegistry_1
	};

	var style$1 = index.style;

	function t$1(){return t$1=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var r in o)Object.prototype.hasOwnProperty.call(o,r)&&(e[r]=o[r]);}return e;},t$1.apply(this,arguments);}function o(e,t){if(null==e)return {};var o,r,n=function(e,t){if(null==e)return {};var o,r,n={},l=Object.keys(e);for(r=0;r<l.length;r++)o=l[r],t.indexOf(o)>=0||(n[o]=e[o]);return n;}(e,t);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(e);for(r=0;r<l.length;r++)o=l[r],t.indexOf(o)>=0||Object.prototype.propertyIsEnumerable.call(e,o)&&(n[o]=e[o]);}return n;}var fA=["size","color","stroke"];function zA(r){var n=r.size,l=void 0===n?24:n,a=r.color,i=void 0===a?"currentColor":a,c=r.stroke,s=void 0===c?2:c,h=o(r,fA);return/*#__PURE__*/e$1.createElement("svg",t$1({xmlns:"http://www.w3.org/2000/svg",className:"icon icon-tabler icon-tabler-clock",width:l,height:l,viewBox:"0 0 24 24",strokeWidth:s,stroke:i,fill:"none",strokeLinecap:"round",strokeLinejoin:"round"},h),/*#__PURE__*/e$1.createElement("path",{stroke:"none",d:"M0 0h24v24H0z",fill:"none"}),/*#__PURE__*/e$1.createElement("circle",{cx:12,cy:12,r:9}),/*#__PURE__*/e$1.createElement("polyline",{points:"12 7 12 12 15 15"}));}

	var dateConvertDdMmmYyyy = function dateConvertDdMmmYyyy(inputFormat) {
	  var pad = function pad(s) {
	    return s < 10 ? "0".concat(s) : s;
	  };
	  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	  var d = new Date(inputFormat);
	  return "".concat(pad(d.getDate()), " ").concat(monthNames[d.getMonth()].substr(0, 3), " ").concat(d.getFullYear());
	};

	var ReadMore = function ReadMore(_ref) {
	  var children = _ref.children;
	  var text = children;
	  var _React$useState = e$1__default.useState(true),
	    _React$useState2 = _slicedToArray(_React$useState, 2),
	    isReadMore = _React$useState2[0],
	    setIsReadMore = _React$useState2[1];
	  var toggleReadMore = function toggleReadMore() {
	    setIsReadMore(!isReadMore);
	  };
	  return (text === null || text === void 0 ? void 0 : text.length) > 150 ? /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text",
	    style: {
	      textAlign: "justify"
	    }
	  }, isReadMore ? text.slice(0, 150) : text, /*#__PURE__*/e$1__default.createElement("span", {
	    onClick: toggleReadMore,
	    className: "read-or-hide"
	  }, isReadMore ? /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      cursor: "pointer"
	    }
	  }, "...", /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      color: "#1B8884"
	    }
	  }, " read more")) : /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      color: "#1B8884",
	      cursor: "pointer"
	    }
	  }, " read less"))) : /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text",
	    style: {
	      textAlign: "justify"
	    }
	  }, text);
	};
	var ThumbIcon = function ThumbIcon() {
	  return /*#__PURE__*/e$1__default.createElement(e$1__default.Fragment, null, /*#__PURE__*/e$1__default.createElement("svg", {
	    width: "11",
	    height: "12",
	    viewBox: "0 0 11 12",
	    fill: "none",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/e$1__default.createElement("path", {
	    d: "M9.61972 4.43893L6.90436 4.09799C7.13251 3.55289 7.39691 2.68781 7.39691 1.60657C7.39691 1.0004 7.20236 0.553528 6.81866 0.278503C6.56085 0.09375 6.22943 0 5.83374 0H5.81415L5.79474 0.00219727C5.14462 0.074707 4.94888 0.682343 4.97516 1.07822C4.97845 1.18021 4.96765 1.28018 4.94312 1.37531C4.87061 1.65582 4.75067 1.88965 4.46091 2.45462L4.44736 2.4809C4.25381 2.85883 4.03143 2.9946 3.72372 3.18256C3.46161 3.34268 3.16452 3.52405 2.84399 3.87469C2.69897 4.03299 2.53198 4.26443 2.38367 4.51263C2.35675 4.54852 2.33395 4.58908 2.31473 4.63467C2.31235 4.63934 2.30978 4.64355 2.30731 4.64777C2.30026 4.66013 2.29083 4.67651 2.28085 4.69629C2.26602 4.72366 2.24954 4.75424 2.2326 4.78665C1.95428 5.02826 1.52408 5.02368 1.2626 5.02075C1.23569 5.02048 1.21088 5.0202 1.18845 5.0202C0.730042 5.0202 0.458862 5.20001 0.312195 5.35089C0.108032 5.56064 0.000183094 5.85718 0.000183094 6.20837L0 10.0336C0 10.2856 0.0320435 10.6494 0.309357 10.9004C0.568268 11.1347 0.93512 11.1618 1.18845 11.1618H2.02515C2.2305 11.1618 2.42844 11.25 2.6792 11.3617C2.82083 11.4248 2.98141 11.4963 3.16516 11.5608C4.02768 11.8596 5.17557 11.9988 6.77747 11.9988C7.08792 11.9988 8.05087 12 8.05133 12C8.39859 12 8.72543 11.8637 8.99634 11.6059C9.13989 11.4695 9.22714 11.2979 9.26294 11.0815C9.27081 11.0336 9.27603 10.9327 9.27658 10.878C9.28207 10.7409 9.26193 10.6104 9.21872 10.4906C9.49695 10.4592 9.75943 10.3391 9.96011 10.1473C10.2063 9.91205 10.3419 9.58521 10.3419 9.22687C10.3419 8.9642 10.2587 8.71609 10.1046 8.5123C10.1956 8.46744 10.2818 8.40939 10.3587 8.33459C10.5581 8.14069 10.6612 7.87189 10.6654 7.53552C10.6783 7.19998 10.5614 6.9082 10.3417 6.6926C10.5742 6.46069 10.7269 6.12854 10.7427 5.76022C10.7726 5.06561 10.2702 4.47647 9.61972 4.43893Z",
	    fill: "white"
	  })));
	};
	var Desktop = function Desktop(_ref2) {
	  var _data$rvwr_post_date;
	  var data = _ref2.data;
	  return /*#__PURE__*/e$1__default.createElement(e$1__default.Fragment, null, /*#__PURE__*/e$1__default.createElement("div", {
	    id: "desktop-default",
	    className: "jsx-3348615074" + " " + "container-desktop grid"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "col-2 side-profile display-flex"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "header-top"
	  }, /*#__PURE__*/e$1__default.createElement("img", {
	    src: data.user.profile_picture,
	    alt: "",
	    className: "jsx-3348615074"
	  }), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "user-info"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      fontWeight: "600"
	    },
	    className: "jsx-3348615074"
	  }, data.user.username), /*#__PURE__*/e$1__default.createElement("p", {
	    className: "jsx-3348615074"
	  }, data.user.skin.type), /*#__PURE__*/e$1__default.createElement("p", {
	    className: "jsx-3348615074"
	  }, data.user.age_range)))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "col-10"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "container-desktop-header"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "header-middle"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, /*#__PURE__*/e$1__default.createElement(RatingStar, {
	    type: 1,
	    rating: data.rating
	  })), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, dateConvertDdMmmYyyy((_data$rvwr_post_date = data.rvwr_post_date) !== null && _data$rvwr_post_date !== void 0 ? _data$rvwr_post_date : data.created_at))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "header-bottom"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "circle"
	  }, /*#__PURE__*/e$1__default.createElement(ThumbIcon, null))), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, "Recommends this product!"))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "container-desktop-comment"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, /*#__PURE__*/e$1__default.createElement(ReadMore, null, data.text))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3348615074" + " " + "container-desktop-footer"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, /*#__PURE__*/e$1__default.createElement(zA, null)), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, "Usage Period : "), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3348615074"
	  }, data.duration_of_use)))), /*#__PURE__*/e$1__default.createElement(style$1, {
	    id: "3348615074"
	  }, "#desktop-default.container-desktop.jsx-3348615074{width:90%;height:auto;box-sizing:border-box;padding:28px 0 28px 0;border-bottom:1px solid #DFE3E8;}#desktop-default.grid.jsx-3348615074{margin:1em 0;display:grid;grid-template-columns:repeat(12,1fr);grid-gap:2px;counter-reset:div;}#desktop-default.jsx-3348615074 .col-2.jsx-3348615074{grid-column:auto/span 2;}#desktop-default.jsx-3348615074 .col-10.jsx-3348615074{grid-column:auto/span 10;}#desktop-default.jsx-3348615074 .side-profile.jsx-3348615074{-webkit-align-self:start;-ms-flex-item-align:start;align-self:start;margin:14px 14px 20px 0;}#desktop-default.jsx-3348615074 .circle.jsx-3348615074{display:inline-block;border-radius:50%;padding:.02em .45em;background:#50BF78;}#desktop-default.jsx-3348615074 .header-top.jsx-3348615074{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:start;-webkit-box-align:start;-ms-flex-align:start;align-items:start;font-size:16px;line-height:16px;font-weight:400;}#desktop-default.jsx-3348615074 .header-top.jsx-3348615074 img.jsx-3348615074{width:60px;height:60px;border-radius:100%;margin-right:24px;margin-bottom:16px;}#desktop-default.jsx-3348615074 .user-info.jsx-3348615074{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;word-break:break-all;}#desktop-default.jsx-3348615074 .user-info.jsx-3348615074 span.jsx-3348615074{margin-bottom:4px;}#desktop-default.jsx-3348615074 .user-info.jsx-3348615074 p.jsx-3348615074{font-family:'Poppins';font-style:normal;font-weight:400;font-size:14px;line-height:22px;margin:0 0 4px;color:#637381;}#desktop-default.jsx-3348615074 .header-middle.jsx-3348615074{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex:row;-ms-flex:row;flex:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin:14px 0;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-default.jsx-3348615074 .header-middle.jsx-3348615074 span.jsx-3348615074:last-child{color:#919EAB;font-size:16px;font-weight:400;line-height:16px;-webkit-letter-spacing:0em;-moz-letter-spacing:0em;-ms-letter-spacing:0em;letter-spacing:0em;}#desktop-default.jsx-3348615074 .header-bottom.jsx-3348615074{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-default.jsx-3348615074 .header-bottom.jsx-3348615074 span.jsx-3348615074:last-child{margin-left:8px;color:#454F5B;font-weight:600;line-height:100%;}#desktop-default.jsx-3348615074 .container-desktop-comment.jsx-3348615074{color:#454F5B;margin:16px 0 20px 0;overflow-wrap:break-word;}#desktop-default.jsx-3348615074 .container-desktop-footer.jsx-3348615074{color:#454F5B;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-default.jsx-3348615074 .container-desktop-footer.jsx-3348615074 span.jsx-3348615074:first-child{margin-right:10px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}#desktop-default.jsx-3348615074 .container-desktop-footer.jsx-3348615074 span.jsx-3348615074:last-child{margin-left:10px;font-weight:600;color:#000000;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=default.js */"));
	};

	var ReadMore$1 = function ReadMore(_ref) {
	  var children = _ref.children;
	  var text = children;
	  var _React$useState = e$1__default.useState(true),
	    _React$useState2 = _slicedToArray(_React$useState, 2),
	    isReadMore = _React$useState2[0],
	    setIsReadMore = _React$useState2[1];
	  var toggleReadMore = function toggleReadMore() {
	    setIsReadMore(!isReadMore);
	  };
	  return (text === null || text === void 0 ? void 0 : text.length) > 150 ? /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text",
	    style: {
	      textAlign: "justify"
	    }
	  }, isReadMore ? text.slice(0, 150) : text, /*#__PURE__*/e$1__default.createElement("span", {
	    onClick: toggleReadMore,
	    className: "read-or-hide"
	  }, isReadMore ? /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      cursor: "pointer"
	    }
	  }, "...", /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      color: "#1b8884"
	    }
	  }, " Read More")) : /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      color: "#1b8884",
	      cursor: "pointer"
	    }
	  }, " Read Less"))) : /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text",
	    style: {
	      textAlign: "justify"
	    }
	  }, text);
	};
	var Desktop$1 = function Desktop() {
	  return /*#__PURE__*/e$1__default.createElement("div", {
	    id: "desktop-type-2",
	    className: "jsx-3020179535" + " " + "container-desktop"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "container-desktop-header"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "header-top"
	  }, /*#__PURE__*/e$1__default.createElement("img", {
	    src: "https://i.pinimg.com/originals/ae/ec/c2/aeecc22a67dac7987a80ac0724658493.jpg",
	    alt: "",
	    className: "jsx-3020179535"
	  }), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "user-info"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    style: {
	      fontWeight: "600"
	    },
	    className: "jsx-3020179535"
	  }, "Devisilva"), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, "15 - 20 | Combination"))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "header-middle"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, /*#__PURE__*/e$1__default.createElement(RatingStar, {
	    type: 1,
	    rating: 5
	  })), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, "04 May 2021")), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "header-bottom"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    style: {
	      color: "#50BF78",
	      fontSize: "25px"
	    },
	    className: "jsx-3020179535" + " " + "icon-ic_thumbs_up_active"
	  })), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, "Recommends this product!"))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "container-desktop-comment"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, /*#__PURE__*/e$1__default.createElement(ReadMore$1, null, "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque in dolor eu leo eleifend hendrerit at sed ex. Praesent molestie odio arcu, in bibendum enim bibendum pharetra. Cras sagittis purus quis ornare sodales. Mauris convallis elit in purus malesuada laoreet. Maecenas sed gravida dui. Aenean sollicitudin nibh nec purus tempor porttitor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Mauris lorem purus, dapibus id malesuada id, semper eu nulla. Suspendisse consectetur pulvinar erat, eu fringilla tortor pulvinar et. Vestibulum eros eros, finibus at lobortis in, scelerisque quis urna. Praesent orci felis, tincidunt sed gravida vel, egestas sit amet odio. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec non risus dolor. Sed felis massa, condimentum nec diam ac, porta tristique sem. Nulla facilisi. Donec convallis nulla in mollis auctor."))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-3020179535" + " " + "container-desktop-footer"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, /*#__PURE__*/e$1__default.createElement(zA, null)), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, "Usage Period : "), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-3020179535"
	  }, "1 month - 3 months")), /*#__PURE__*/e$1__default.createElement(style$1, {
	    id: "3020179535"
	  }, "#desktop-type-2.container-desktop.jsx-3020179535{width:90%;height:auto;box-sizing:border-box;padding:16px 16px 16px 0;}#desktop-type-2.jsx-3020179535 .header-top.jsx-3020179535{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px;line-height:16px;font-weight:400;}#desktop-type-2.jsx-3020179535 .header-top.jsx-3020179535 img.jsx-3020179535{width:45px;height:45px;border-radius:100%;margin-right:24px;}#desktop-type-2.jsx-3020179535 .user-info.jsx-3020179535{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;word-break:break-all;}#desktop-type-2.jsx-3020179535 .user-info.jsx-3020179535 span.jsx-3020179535:first-child{margin-bottom:4px;}#desktop-type-2.jsx-3020179535 .header-middle.jsx-3020179535{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex:row;-ms-flex:row;flex:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin:14px 0;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-type-2.jsx-3020179535 .header-middle.jsx-3020179535 span.jsx-3020179535:last-child{color:#919EAB;font-size:16px;font-weight:400;line-height:16px;-webkit-letter-spacing:0em;-moz-letter-spacing:0em;-ms-letter-spacing:0em;letter-spacing:0em;}#desktop-type-2.jsx-3020179535 .header-bottom.jsx-3020179535{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-type-2.jsx-3020179535 .header-bottom.jsx-3020179535 span.jsx-3020179535:last-child{margin-left:8px;color:#454F5B;font-weight:600;line-height:100%;}#desktop-type-2.jsx-3020179535 .container-desktop-comment.jsx-3020179535{color:#454F5B;margin:16px 0 20px 0;overflow-wrap:break-word;}#desktop-type-2.jsx-3020179535 .container-desktop-footer.jsx-3020179535{color:#454F5B;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#desktop-type-2.jsx-3020179535 .container-desktop-footer.jsx-3020179535 span.jsx-3020179535:first-child{margin-right:10px;}#desktop-type-2.jsx-3020179535 .container-desktop-footer.jsx-3020179535 span.jsx-3020179535:last-child{margin-left:10px;font-weight:600;color:#000000;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=type-2.js */"));
	};

	var _excluded = ["type"];
	var Template = [{
	  id: "default",
	  component: Desktop
	}, {
	  id: "type-2",
	  component: Desktop$1
	}];
	var Desktop$2 = function Desktop(_ref) {
	  var type = _ref.type,
	    otherProps = _objectWithoutProperties(_ref, _excluded);
	  return Template.filter(function (item) {
	    return item.id === type;
	  }).map(function (style, idx) {
	    return /*#__PURE__*/e$1__default.createElement(style.component, _extends({
	      key: String(idx)
	    }, otherProps));
	  });
	};

	var ReadMore$2 = function ReadMore(_ref) {
	  var children = _ref.children;
	  var text = children;
	  var _React$useState = e$1__default.useState(true),
	    _React$useState2 = _slicedToArray(_React$useState, 2),
	    isReadMore = _React$useState2[0],
	    setIsReadMore = _React$useState2[1];
	  var toggleReadMore = function toggleReadMore() {
	    setIsReadMore(!isReadMore);
	  };
	  return (text === null || text === void 0 ? void 0 : text.length) > 150 ? /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text"
	  }, isReadMore ? text.slice(0, 150) : text, /*#__PURE__*/e$1__default.createElement("span", {
	    onClick: toggleReadMore,
	    className: "read-or-hide"
	  }, isReadMore ? /*#__PURE__*/e$1__default.createElement("span", {
	    className: "dots"
	  }, "...", /*#__PURE__*/e$1__default.createElement("span", {
	    className: "read-more"
	  }, " Read More")) : /*#__PURE__*/e$1__default.createElement("span", {
	    className: "read-less"
	  }, " Read Less"))) : /*#__PURE__*/e$1__default.createElement("p", {
	    className: "text"
	  }, text);
	};
	var ThumbIcon$1 = function ThumbIcon() {
	  return /*#__PURE__*/e$1__default.createElement(e$1__default.Fragment, null, /*#__PURE__*/e$1__default.createElement("svg", {
	    width: "11",
	    height: "12",
	    viewBox: "0 0 11 12",
	    fill: "none",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/e$1__default.createElement("path", {
	    d: "M9.61972 4.43893L6.90436 4.09799C7.13251 3.55289 7.39691 2.68781 7.39691 1.60657C7.39691 1.0004 7.20236 0.553528 6.81866 0.278503C6.56085 0.09375 6.22943 0 5.83374 0H5.81415L5.79474 0.00219727C5.14462 0.074707 4.94888 0.682343 4.97516 1.07822C4.97845 1.18021 4.96765 1.28018 4.94312 1.37531C4.87061 1.65582 4.75067 1.88965 4.46091 2.45462L4.44736 2.4809C4.25381 2.85883 4.03143 2.9946 3.72372 3.18256C3.46161 3.34268 3.16452 3.52405 2.84399 3.87469C2.69897 4.03299 2.53198 4.26443 2.38367 4.51263C2.35675 4.54852 2.33395 4.58908 2.31473 4.63467C2.31235 4.63934 2.30978 4.64355 2.30731 4.64777C2.30026 4.66013 2.29083 4.67651 2.28085 4.69629C2.26602 4.72366 2.24954 4.75424 2.2326 4.78665C1.95428 5.02826 1.52408 5.02368 1.2626 5.02075C1.23569 5.02048 1.21088 5.0202 1.18845 5.0202C0.730042 5.0202 0.458862 5.20001 0.312195 5.35089C0.108032 5.56064 0.000183094 5.85718 0.000183094 6.20837L0 10.0336C0 10.2856 0.0320435 10.6494 0.309357 10.9004C0.568268 11.1347 0.93512 11.1618 1.18845 11.1618H2.02515C2.2305 11.1618 2.42844 11.25 2.6792 11.3617C2.82083 11.4248 2.98141 11.4963 3.16516 11.5608C4.02768 11.8596 5.17557 11.9988 6.77747 11.9988C7.08792 11.9988 8.05087 12 8.05133 12C8.39859 12 8.72543 11.8637 8.99634 11.6059C9.13989 11.4695 9.22714 11.2979 9.26294 11.0815C9.27081 11.0336 9.27603 10.9327 9.27658 10.878C9.28207 10.7409 9.26193 10.6104 9.21872 10.4906C9.49695 10.4592 9.75943 10.3391 9.96011 10.1473C10.2063 9.91205 10.3419 9.58521 10.3419 9.22687C10.3419 8.9642 10.2587 8.71609 10.1046 8.5123C10.1956 8.46744 10.2818 8.40939 10.3587 8.33459C10.5581 8.14069 10.6612 7.87189 10.6654 7.53552C10.6783 7.19998 10.5614 6.9082 10.3417 6.6926C10.5742 6.46069 10.7269 6.12854 10.7427 5.76022C10.7726 5.06561 10.2702 4.47647 9.61972 4.43893Z",
	    fill: "white"
	  })));
	};
	var Mobile = function Mobile(_ref2) {
	  var _data$rvwr_post_date;
	  var data = _ref2.data;
	  return /*#__PURE__*/e$1__default.createElement("div", {
	    id: "mobile-default",
	    className: "jsx-1817662312" + " " + "container-mobile"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "container-mobile-header"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "header-top"
	  }, /*#__PURE__*/e$1__default.createElement("img", {
	    src: data.user.profile_picture,
	    alt: "",
	    className: "jsx-1817662312"
	  }), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "user-info"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, data.user.username), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "desc"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312" + " " + "skin"
	  }, data.user.skin.type), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312" + " " + "age"
	  }, data.user.age_range)))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "header-middle"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, /*#__PURE__*/e$1__default.createElement(RatingStar, {
	    type: 1,
	    rating: data.rating
	  })), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, dateConvertDdMmmYyyy((_data$rvwr_post_date = data.rvwr_post_date) !== null && _data$rvwr_post_date !== void 0 ? _data$rvwr_post_date : data.created_at))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "header-bottom"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "circle"
	  }, /*#__PURE__*/e$1__default.createElement(ThumbIcon$1, null))), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, "Recommends this product!"))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "container-mobile-comment"
	  }, /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, /*#__PURE__*/e$1__default.createElement(ReadMore$2, null, data.text))), /*#__PURE__*/e$1__default.createElement("div", {
	    className: "jsx-1817662312" + " " + "container-mobile-footer"
	  }, /*#__PURE__*/e$1__default.createElement(zA, null), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, "Usage Period : "), /*#__PURE__*/e$1__default.createElement("span", {
	    className: "jsx-1817662312"
	  }, data.duration_of_use)), /*#__PURE__*/e$1__default.createElement(style$1, {
	    id: "1817662312"
	  }, "#mobile-default.container-mobile.jsx-1817662312{width:100%;height:auto;box-sizing:border-box;padding:16px;}#mobile-default.jsx-1817662312 .header-top.jsx-1817662312{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:16px;line-height:16px;font-weight:400;}#mobile-default.jsx-1817662312 .header-top.jsx-1817662312 img.jsx-1817662312{width:45px;height:45px;border-radius:100%;margin-right:24px;}#mobile-default.jsx-1817662312 .user-info.jsx-1817662312{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;font-weight:400;font-style:normal;font-size:14px;line-height:16px;word-break:break-all;}#mobile-default.jsx-1817662312 .circle.jsx-1817662312{display:inline-block;border-radius:50%;padding:.02em .45em;background:#50BF78;}#mobile-default.jsx-1817662312 .user-info.jsx-1817662312 span.jsx-1817662312:first-child{margin-bottom:4px;font-weight:600;}#mobile-default.jsx-1817662312 .user-info.jsx-1817662312 .desc.jsx-1817662312 span.jsx-1817662312{font-style:normal;font-weight:400;font-size:14px;line-height:22px;color:#637381;position:relative;padding:0 8px 0 0;}#mobile-default.jsx-1817662312 .user-info.jsx-1817662312 .desc.jsx-1817662312 span.jsx-1817662312:not(:first-child){margin-left:8px;}#mobile-default.jsx-1817662312 .user-info.jsx-1817662312 .desc.jsx-1817662312 span.skin.jsx-1817662312:after{content:\"\";width:1.5px;height:75%;background-color:#DFE3E8;right:0;position:absolute;display:block;top:15%;}#mobile-default.jsx-1817662312 .header-middle.jsx-1817662312{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex:row;-ms-flex:row;flex:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin:14px 0;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#mobile-default.jsx-1817662312 .header-middle.jsx-1817662312 span.jsx-1817662312:last-child{color:#919EAB;font-size:14px;font-weight:400;line-height:16px;-webkit-letter-spacing:0em;-moz-letter-spacing:0em;-ms-letter-spacing:0em;letter-spacing:0em;}#mobile-default.jsx-1817662312 .header-bottom.jsx-1817662312{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}#mobile-default.jsx-1817662312 .header-bottom.jsx-1817662312 span.jsx-1817662312:last-child{margin-left:8px;color:#454F5B;font-weight:600;line-height:100%;font-size:12px;line-height:12px;}#mobile-default.jsx-1817662312 .container-mobile-comment.jsx-1817662312{color:#454F5B;margin:16px 0 20px 0;font-weight:400;font-style:normal;font-size:14px;line-height:22px;}#mobile-default.jsx-1817662312 .container-mobile-comment.jsx-1817662312 span.jsx-1817662312 p.text.jsx-1817662312{text-align:justify;word-break:break-word;}#mobile-default.jsx-1817662312 .container-mobile-comment.jsx-1817662312 span.jsx-1817662312 p.text.jsx-1817662312 span.jsx-1817662312 span.dots.jsx-1817662312 span.read-more.jsx-1817662312,#mobile-default.jsx-1817662312 .container-mobile-comment.jsx-1817662312 span.jsx-1817662312 p.text.jsx-1817662312 span.jsx-1817662312 span.read-less.jsx-1817662312{color:#1B8884;cursor:pointer;}#mobile-default.jsx-1817662312 .container-mobile-footer.jsx-1817662312{color:#454F5B;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;line-height:16px;}#mobile-default.jsx-1817662312 .container-mobile-footer.jsx-1817662312 span.jsx-1817662312:not(:first-child){margin-left:10px;}#mobile-default.jsx-1817662312 .container-mobile-footer.jsx-1817662312 span.jsx-1817662312:last-child{font-weight:600;color:#000000;margin-left:auto;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=mobile.js */"));
	};

	/* eslint-disable react/forbid-prop-types */
	var ReviewCard = function ReviewCard(_ref) {
	  var type = _ref.type,
	    isMobile = _ref.isMobile,
	    data = _ref.data;
	  if (!isMobile) {
	    return /*#__PURE__*/e$1__default.createElement(Desktop$2, {
	      data: data,
	      type: type
	    });
	  }
	  return /*#__PURE__*/e$1__default.createElement(Mobile, {
	    data: data
	  });
	};
	ReviewCard.propTypes = {
	  type: propTypes.string,
	  isMobile: propTypes.bool.isRequired,
	  data: propTypes.any.isRequired
	};
	ReviewCard.defaultProps = {
	  type: "default"
	};

	return ReviewCard;

})));
//# sourceMappingURL=review_card_bs.umd.js.map
